import React from 'react';
import { Row } from 'react-bootstrap';
import { SCol, SSocialMediaLinks } from './styles';
import DynamicReactIcon from 'components/DynamicReactIcon';

const SocialMediaIcons = () => {
  return (
    <Row>
      <SCol xs="12" sm="12" md="4" lg="12" xl="12" className="my-auto">
        <SSocialMediaLinks>
          <a href="https://www.twitter.com/oasislivinguk" target="_blank">
            <DynamicReactIcon
              fill="#e85270"
              width={20}
              height={17}
              withBackground={false}
              iconVariant="twitter"
            />
          </a>
          <a href="https://www.facebook.com/oasislivinguk" target="_blank">
            <DynamicReactIcon
              fill="#e85270"
              width={20}
              height={17}
              withBackground={false}
              iconVariant="facebook"
            />
          </a>
          <a href="https://instagram.com/oasislivinguk" target="_blank">
            <DynamicReactIcon
              fill="#e85270"
              width={20}
              height={17}
              withBackground={false}
              iconVariant="instagram"
            />
          </a>
          <a
            href="https://www.linkedin.com/company/oasisliving"
            target="_blank"
          >
            <DynamicReactIcon
              fill="#e85270"
              width={20}
              height={17}
              withBackground={false}
              iconVariant="linkedin"
            />
          </a>
        </SSocialMediaLinks>
      </SCol>
    </Row>
  );
};

export default SocialMediaIcons;
